<script>
import { isNil } from 'lodash';
import moment from 'moment';

import WEventHistStackedColumnChart from '@/views/event/event-hist/components/EventHistStackedColumnChart';
import MapAPI from '@/api/topologymap/common';
import { stackedColumnOptions } from '@/constants/chart-options';

export default {
  name: 'WTopologymapEventHistStackedColumnChart',
  extends: WEventHistStackedColumnChart,
  props: {
    active: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
    };
  },
  computed: {
  },
  watch: {
    active: {
      handler(value) {
        if (value === false) {
          this.clear();
        }
      },
    },
  },
  methods: {
    loadData() {
      if (isNil(this.active) || !this.active) {
        return;
      }
      this.isLoading = true;
      const params = {
        startDatetime: moment().subtract(1, 'days').valueOf(),
        endDatetime: moment().valueOf(),
        filterParams: this.filterParams,
        mapId: this.$store.getters.getCurrentMapId,
      };
      MapAPI.getEventHistChartData(params).then((response) => {
        this.options.series = response.data.data;
      }).finally(() => {
        this.isLoading = false;
      });
    },
    clear() {
      this.isLoading = false;
      this.options.series = stackedColumnOptions.series;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/event/TopologymapEventHistStackedColumnChart.vue